import React, {Component, Fragment} from 'react';
import {connect} from "react-redux";
import {
    setCurrentStep,
    setErrorMessage,
    setInternetBankKey,
    setPaymentCompany,
    setResultError,
    setInternetBankInitStatus,
    setInternetBankAmount, setInternetBankDescription,
} from "../../redux/app/app.actions";
import {withTranslation} from 'react-i18next';
import Select from "../../commons/form/Select";
import Button from "../../commons/form/Button";
import Api from "../../services/Api";
import StepProgressBar from "../../commons/progress/StepProgressBar";
import MD5 from "crypto-js/md5";
import Utils from "../../services/Utils";
import InputMask from "../../commons/form/InputMask";
import utils from "../../services/Utils";

class Index extends Component {
    constructor(props) {
        super(props);
        this.state = {
            isLoaded: false,
            buttonProgress: false,
            amountList: [],
            canUserEnterCustomAmount: 0,
            minimumAmount: 0,
            amount: {value: '', error: null},
            mobile: {value: '', error: null},
            nationalCode: {value: '', error: null},
            birthDate: {value: '', error: null},
            igpSteps: {
                // stepProgressBar: [props.t('login'), props.t('verifyCode'), props.t('card'), props.t('complete')],
                // steps: {1: 'login', 2: 'verify', 3: 'transfer', 100: 'result'}
                stepProgressBar: [props.t('info'), props.t('verify'), props.t('card'), props.t('complete')],
                steps: {2: 'verify', 3: 'transfer', 100: 'result'}
            }
        };

        this.componentsMapCache = new Map();
    }

    componentDidMount() {
        this.getInitData();
    }

    getInitData = () => {
        Api.post('ipg/get-init-data', {
            refCode: this.props.refCode,
        }).then(res => {
            const data = res.data;

            let amountList = data.data.amountList.reduce((obj, item) => {
                obj[item] = item.toLocaleString();
                return obj;
            }, {});

            this.setState({
                amountList: amountList,
                canUserEnterCustomAmount: data.data.canUserEnterCustomAmount,
                minimumAmount: data.data.minimumAmount,
            });
        }).catch((error) => {
            if (error.response) {
                this.props.setResultError(error.response.data.message !== undefined ? error.response.data.message : 'خطا');
                this.props.setCurrentStep(100);
            }
        })
    }

    handleSubmit = async (event) => {
        event.preventDefault();
        if (!this.isValidForm()) {
            return false;
        }

        this.props.setErrorMessage(null);
        this.setState({buttonProgress: true});

        let initRes = await Api.post('ipg/route/init', {
            refCode: this.props.refCode,
            amount: this.state.amount.value,
            nationalCode: this.state.nationalCode.value,
            birthDate: this.state.birthDate.value,
            mobileNumber: this.state.mobile.value,
        }).then(res => {
            // const data = res.data;
            // this.props.setInternetBankDescription(res.data.data.description);
            this.props.setInternetBankAmount(this.state.amount.value);
        }).catch((error) => {
            if (error.response.status != null && error.response.status === 400) {
                this.props.setErrorMessage(error.response.data.message);
            }

            this.setState({buttonProgress: false});

            return false;
        })

        if (initRes === false) {
            return false;
        }

        Api.post('card-payment/verify-route', {
            refCode: this.props.refCode,
            phoneNumber: this.state.mobile.value,
            bank: null,
            method: 'login',
        }).then(res => {
            this.setState({
                loading: false,
            });
            this.setState({buttonProgress: false});

            if (res.data.status !== undefined && res.data.status === true) {
                if (res.data.login !== undefined && res.data.login === false) {
                    this.props.setCurrentStep(2);
                } else {
                    this.props.setCurrentStep(3);
                }
            } else {
                this.props.setErrorMessage(res.data.message);
                return false;
            }

            this.props.setInternetBankInitStatus(true);

        }).catch((error) => {
            this.setState({buttonProgress: false});

            this.props.setErrorMessage(error.response.data.message);
        });


        // this.props.setErrorMessage(null);
    }

    isValidForm = () => {
        const {t} = this.props;

        let errors = {amount: '', mobile: '', nationalCode: '', birthDate: ''};

        let isFormValid = true;
        const {amount, mobile, minimumAmount, nationalCode, birthDate} = this.state;

        // if (bankServiceKey.value === '') {
        //     isFormValid = false;
        //     errors.bankServiceKey = t('chooseOption');
        // }

        if (amount.value === '') {
            isFormValid = false;
            errors.amount = t('chooseOption');
        }

        if (nationalCode.value === '') {
            isFormValid = false;
            errors.nationalCode = t('fillInput');
        }

        if (birthDate.value === '') {
            isFormValid = false;
            errors.birthDate = t('fillInput');
        }

        if (amount.value < minimumAmount) {
            isFormValid = false;
            errors.amount = 'حداقل مبلغ وارد شده باید بیش از ' + utils.showAsNumberFormat(minimumAmount) + ' باشد. ';
        }

        if (mobile.value === '') {
            isFormValid = false;
            errors.mobile = t('fillInput');
        } else if (mobile.value.length !== 11) {
            errors.mobile = t('mobileLengthError');
            isFormValid = false;
        }

        this.setState(prevState => ({
            amount: {...prevState.amount, error: errors.amount},
            mobile: {...prevState.mobile, error: errors.mobile},
            nationalCode: {...prevState.nationalCode, error: errors.nationalCode},
            birthDate: {...prevState.birthDate, error: errors.birthDate},
        }));

        return isFormValid;
    }

    handleChange = (event, mask = false) => {
        const {value, rawValue, name, maxLength} = event.target;

        if (maxLength !== -1 && maxLength < value.toString().length) {
            return false
        }

        this.setState(prevState => ({[name]: {...prevState[name], 'value': !mask ? value : rawValue, 'error': null}}));
    }

    choosePaymentMethod = (paymentMethodId, company) => {
        this.props.setPaymentCompany({
            paymentMethodId: paymentMethodId,
            company: company,
        })
    }

    title(title, tr, lang) {
        return tr != null && lang in tr ? tr[lang] : title;
    }

    getLazyComponent = (currentStep) => {
        let key = currentStep;

        let cacheKey = MD5(key).toString();
        if (this.componentsMapCache.has(cacheKey)) return this.componentsMapCache.get(cacheKey);

        let Router;

        let currentStepComponentName = this.state.igpSteps.steps[currentStep];

        let component;

        component = React.lazy(() =>
            import('./' + Utils.capitalizeFirstChar(currentStepComponentName))
        );
        /*        if (currentStepComponentName === 'transfer') {
                    component = React.lazy(() =>
                        import('./transfer/Transfer'));
                } else {
                    component = React.lazy(() =>
                        import('./' + bankKey + '/' + Utils.capitalizeFirstChar(currentStepComponentName)));
                }*/

        Router = React.createElement(component);


        this.componentsMapCache.set(cacheKey, Router);

        return Router;
    }

    render() {
        console.log(this.state)
        const {t} = this.props;
        const {nationalCode, birthDate,  amount, mobile} = this.state;

        let MyLazyComponent = null;
        if (this.props.internetBank.initStatus === true) {
            MyLazyComponent = this.getLazyComponent(this.props.currentStep);
        }

        return (
            <div className="internet-bank">
                {
                    this.props.internetBank.initStatus === false ?
                        <div className="ctc-gateway">
                            <form onSubmit={this.handleSubmit}>

                                <p></p>

                                <InputMask
                                    handleChange={(e) => {
                                        this.handleChange(e, true)
                                    }}
                                    name="mobile"
                                    value={mobile.value}
                                    container={{'class': 'mb-3'}}
                                    label={{text: t('mobilePlaceHolder')}}
                                    error={{text: mobile.error}}
                                    placeholder={t('mobileNumber')}
                                    autoComplete="off"
                                    className="form-control ltr"
                                    options={{
                                        blocks: [4, 3, 4],
                                        numericOnly: true,
                                    }}
                                />
                                <InputMask
                                    handleChange={(e) => {
                                        this.handleChange(e, true)
                                    }}
                                    name="nationalCode"
                                    value={nationalCode.value}
                                    container={{'class': 'mb-3'}}
                                    label={{text: t('nationalCodePlaceHolder')}}
                                    error={{text: nationalCode.error}}
                                    placeholder={t('nationalCode')}
                                    autoComplete="off"
                                    className="form-control ltr"
                                    options={{
                                        blocks: [10],
                                        numericOnly: true,
                                    }}
                                />

                                <InputMask
                                    handleChange={(e) => {
                                        this.handleChange(e, true)
                                    }}
                                    name="birthDate"
                                    value={birthDate.value}
                                    container={{'class': 'mb-3'}}
                                    label={{text: t('birthDatePlaceHolder')}}
                                    error={{text: birthDate.error}}
                                    placeholder={t('birthDate')}
                                    autoComplete="off"
                                    className="form-control ltr"
                                    options={{
                                        blocks: [4, 2, 2],
                                        delimiter: '/',
                                        numericOnly: true,
                                    }}
                                />

                                {
                                    this.state.canUserEnterCustomAmount === 1 ?
                                        <InputMask
                                            handleChange={(e) => {
                                                this.handleChange(e, true)
                                            }}
                                            name="amount"
                                            value={amount.value}
                                            container={{'class': 'mb-3'}}
                                            label={{text: "مبلغ پرداختی را وارد نمایید"}}
                                            error={{text: amount.error}}
                                            placeholder="0"
                                            autoComplete="off"
                                            className="form-control ltr"
                                            options={{
                                                numericOnly: true,
                                            }}
                                        />
                                        :

                                        <Select
                                            name="amount"
                                            value={amount.value}
                                            handleChange={this.handleChange}
                                            container={{'class': 'mb-3'}}
                                            options={this.state.amountList}
                                            label={{text: "مبلغ پرداختی را انتخاب نمایید"}}
                                            error={{text: amount.error}}
                                            className="form-control"
                                        />
                                }


                                <div className="d-flex flex-row-reverse justify-content-between mb-3">
                                    <Button
                                        text={t('next')}
                                        progress={this.state.buttonProgress}
                                        disabled={this.state.buttonProgress}
                                    />
                                </div>
                            </form>
                        </div>
                        : null
                }

                {
                    this.props.internetBank.initStatus === true && MyLazyComponent !== null ?
                        <>
                            <StepProgressBar
                                titleArray={this.state.igpSteps.stepProgressBar}/>

                            {
                                MyLazyComponent
                            }
                        </>

                        :

                        null
                }
            </div>
        )
    }
}

const mapStateToProps = state => {
    return state.app;
}

const mapDispatchToProps = dispatch => ({
        setPaymentCompany: obj => dispatch(setPaymentCompany(obj)),
        setErrorMessage: errorMessage => dispatch(setErrorMessage(errorMessage)),
        setResultError: errorMessage => dispatch(setResultError(errorMessage)),
        setCurrentStep: step => dispatch(setCurrentStep(step)),
        setInternetBankKey: bankKey => dispatch(setInternetBankKey(bankKey)),
        setInternetBankDescription: description => dispatch(setInternetBankDescription(description)),
        setInternetBankInitStatus: status => dispatch(setInternetBankInitStatus(status)),
        setInternetBankAmount: amount => dispatch(setInternetBankAmount(amount)),
    }
);

export default connect(mapStateToProps, mapDispatchToProps)(withTranslation()(Index));
